import { pdf } from "@react-pdf/renderer";
import ChecklistPDF from "./index";

export const generateAndDownloadChecklistPDF = async (headers, checklistData, applicationRoles) => {
  const doc = <ChecklistPDF data={checklistData} applicationRoles={applicationRoles} />;
  const blob = await pdf(doc).toBlob();

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `Checklist EdP ${headers?.contracT_CODE ?? ""} (Nro. EdP ${headers?.nrO_EP ?? ""}).pdf`;
  link.click();
  URL.revokeObjectURL(url);
};
